import { forwardRef } from 'react';
import PropTypes from 'prop-types';

// Figma reference for icon https://www.figma.com/file/OgEpKIi4hsLA1rkS6b8km0/Disponibilidad-de-art%C3%ADculos?node-id=3842%3A794

const EyeOnOutline = forwardRef(function EyeOnOutline(props, ref) {
  const ASPECT_RADIO = 0.275;
  const { color = '#47465F', colorOval = '#F7F7F9', colorOvalInherit = '#CECDD1', size = 47, ...others } = props;

  return (
    <svg
      fill="none"
      height={size - size * ASPECT_RADIO}
      viewBox="0 0 48 35"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <rect
        ref={ref}
        fill={colorOval}
        height={size - size * ASPECT_RADIO}
        rx="17"
        stroke={colorOvalInherit}
        width={size}
        x="0.5"
        y="0.5"
      />
      <path
        clipRule="evenodd"
        d="M14.9751 18.0812C14.9577 18.0519 14.9418 18.0248 14.9273 18C14.9418 17.9752 14.9577 17.9481 14.9751 17.9188C15.0783 17.7451 15.2334 17.495 15.4386 17.194C15.8497 16.5912 16.459 15.7886 17.252 14.9875C18.8459 13.3773 21.1303 11.8235 24 11.8235C26.8698 11.8235 29.1542 13.3773 30.7481 14.9875C31.5411 15.7886 32.1504 16.5912 32.5615 17.194C32.7667 17.495 32.9218 17.7451 33.025 17.9188C33.0424 17.9481 33.0583 17.9752 33.0728 18C33.0583 18.0248 33.0424 18.0519 33.025 18.0812C32.9218 18.2549 32.7667 18.505 32.5615 18.806C32.1504 19.4088 31.5411 20.2114 30.7481 21.0125C29.1542 22.6227 26.8698 24.1765 24 24.1765C21.1303 24.1765 18.8459 22.6227 17.252 21.0125C16.459 20.2114 15.8497 19.4088 15.4386 18.806C15.2334 18.505 15.0783 18.2549 14.9751 18.0812ZM33.5653 18C33.9542 17.8159 33.9541 17.8157 33.954 17.8155L33.5653 18ZM33.954 17.8155C34.0152 17.9314 34.0154 18.0682 33.9542 18.1841L33.5653 18C33.9542 18.1841 33.9539 18.1848 33.9538 18.185L33.953 18.1864L33.9506 18.191L33.9418 18.2072C33.9343 18.221 33.9234 18.241 33.909 18.2666C33.8804 18.3178 33.8383 18.3916 33.7829 18.485C33.6721 18.6715 33.5079 18.9361 33.2919 19.2528C32.8606 19.8853 32.2199 20.7298 31.3825 21.5757C29.7155 23.2597 27.2172 25 24 25C20.7829 25 18.2846 23.2597 16.6176 21.5757C15.7802 20.7298 15.1395 19.8853 14.7081 19.2528C14.4922 18.9361 14.328 18.6715 14.2172 18.485C14.1618 18.3916 14.1196 18.3178 14.091 18.2666C14.0767 18.241 14.0658 18.221 14.0583 18.2072L14.0495 18.191L14.0471 18.1864L14.0463 18.185L14.0459 18.1841L14.4344 18.0002C14.0475 18.1834 14.0458 18.184 14.0459 18.1841M14.0459 18.1841C13.9847 18.0682 13.9847 17.9318 14.0459 17.8159L14.4348 18C14.0459 17.8159 14.0462 17.8152 14.0463 17.815L14.0471 17.8136L14.0495 17.809L14.0583 17.7928C14.0658 17.779 14.0767 17.759 14.091 17.7334C14.1196 17.6822 14.1618 17.6084 14.2172 17.515C14.328 17.3285 14.4922 17.0639 14.7081 16.7472C15.1395 16.1147 15.7802 15.2702 16.6176 14.4243C18.2846 12.7403 20.7829 11 24 11C27.2172 11 29.7155 12.7403 31.3825 14.4243C32.2199 15.2702 32.8606 16.1147 33.2919 16.7472C33.5079 17.0639 33.6721 17.3285 33.7829 17.515C33.8383 17.6084 33.8804 17.6822 33.909 17.7334C33.9234 17.759 33.9343 17.779 33.9418 17.7928L33.9506 17.809L33.953 17.8136L33.954 17.8155M21.8261 18C21.8261 16.8629 22.7994 15.9412 24 15.9412C25.2007 15.9412 26.174 16.8629 26.174 18C26.174 19.1371 25.2007 20.0588 24 20.0588C22.7994 20.0588 21.8261 19.1371 21.8261 18ZM24 15.1176C22.3192 15.1176 20.9565 16.4081 20.9565 18C20.9565 19.5919 22.3192 20.8823 24 20.8823C25.6809 20.8823 27.0435 19.5919 27.0435 18C27.0435 16.4081 25.6809 15.1176 24 15.1176Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
});

EyeOnOutline.propTypes = {
  color: PropTypes.string,
  colorOval: PropTypes.string,
  colorOvalInherit: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EyeOnOutline;
